import ErrorWithCause from '@helpers/ErrorWithCause';
import { isAxiosError } from '@helpers/errorHelper';
import { captureMessage, setTag } from '@sentry/react';
import axios from 'axios';
import { API_BASE_URL, SYMFONY_API_BASE_URL } from '@config/apiConfig';
const getCurrentPaypalState = (error) => {
    var _a;
    if (!isAxiosError(error)) {
        return undefined;
    }
    return (_a = error.response) === null || _a === void 0 ? void 0 : _a.data;
};
const completePaypalDeposit = async (request, isUsePaymentMicroserviceEnabled, correlationId) => {
    var _a;
    const { paypalOrderId, ...requestBody } = request;
    const requestPath = isUsePaymentMicroserviceEnabled
        ? `${API_BASE_URL}/payments/payment-deposit/paypal/`
        : `${SYMFONY_API_BASE_URL}/api/deposit/paypal/v1/`;
    const headers = {
        'X-Correlation-ID': correlationId,
    };
    try {
        const response = await axios.patch(`${requestPath}${paypalOrderId}`, requestBody, { headers });
        return response.data;
    }
    catch (error) {
        const { data: errorData } = (_a = getCurrentPaypalState(error)) !== null && _a !== void 0 ? _a : {};
        let level = 'fatal';
        if (request.newOrderState === 'cancelled' && (errorData === null || errorData === void 0 ? void 0 : errorData.currentState) === 'cancelled') {
            level = 'info';
        }
        setTag('paypalOrderId', request.paypalOrderId);
        setTag('correlationId', correlationId);
        captureMessage('Unable to complete the paypal deposit', {
            level,
            extra: {
                requestMethod: 'PATCH',
                requestPath,
                paypalOrderId: request.paypalOrderId,
                newOrderState: request.newOrderState,
                currentOrderState: errorData === null || errorData === void 0 ? void 0 : errorData.currentState,
                correlationId,
            },
        });
        throw new ErrorWithCause(error);
    }
};
export default completePaypalDeposit;
